import { Modal } from "./ui/Modal";

import { useDemoModal } from "../hooks/useDemoModal";
import { videosAndDemos } from "../data/videos-and-demos";

export const DemoModal = () => {
  const { title, onClose } = useDemoModal();

  const activeDemo = videosAndDemos.find((demo) => demo.title === title);

  if (!activeDemo) return null;

  return (
    <Modal
      isOpen={!!title}
      onClose={onClose}
      className="fixed inset-0 p-[46px] bg-[#06101F]"
    >
      <iframe
        src={activeDemo.src}
        allowFullScreen
        loading="lazy"
        title={activeDemo.title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        className="w-full aspect-video rounded-2xl mb-6"
      ></iframe>

      <h1 className="text-xl font-semibold text-white mb-2">
        {activeDemo.title}
      </h1>
      <p className="text-white max-w-[667px]">{activeDemo.description}</p>
    </Modal>
  );
};
